import { CompanyRoutes } from "Company/Routes/Router";
import { ErrorRoutes } from "Infrastructure/Routes/ErrorRoutes";
import { transferRoutesToComponent } from "Infrastructure/Utilities/RouteUtils";
import { MarketProvider } from "Market/Providers/CurrentMarketProvider";
import { MarketEmptyLayoutRoutes, MarketRoutes } from "Market/Routes/Router";
import { ClaimRoutes } from "Order/Modules/Claim/Routes/Router";
import { InvoiceRoutes } from "Order/Modules/Invoice/Routes/Router";
import { OrderRoutes } from "Order/Routes/Router";
import { OrderPaths } from "Order/Routes/Routing";
import { PartnerStatisticsRoutes } from "Partner/Modules/Statistics/Routes/Router";
import { PartnerRoutes } from "Partner/Routes/Router";
import { PaymentRoutes } from "Payment/Routes/Router";
import { SettingsRoutes } from "Settings/Routes/Router";
import { FullLayout } from "Shared/Components/Layout/Full/FullLayout";
import { Navigate, type RouteObject } from "react-router";
import { SessionAuth } from "supertokens-auth-react/recipe/session";

export type CustomRouteObject = RouteObject & {
	secure: boolean;
};

export const Router = [
	...MarketEmptyLayoutRoutes,
	{
		path: "/",
		element: (
			<SessionAuth>
				<MarketProvider>
					<FullLayout />
				</MarketProvider>
			</SessionAuth>
		),
		children: [
			{ path: "/", element: <Navigate to={OrderPaths.Index.path} /> },
			...OrderRoutes,
			...PartnerRoutes,
			...ClaimRoutes,
			...SettingsRoutes,
			...CompanyRoutes,
			...MarketRoutes,
			...InvoiceRoutes,
			...PartnerStatisticsRoutes,
			...PaymentRoutes,
		],
	},
	...ErrorRoutes,
	{
		path: "*",
		element: <></>,
	},
];

export const getRoutes = () => {
	return transferRoutesToComponent(Router);
};
